export default __webpack_public_path__ + "static/media/news-5.722a5540.png";